export default "__VITE_ASSET__BvqhR0xq__"